{
  "es": {
    "datetime": {
      "formats": {
        "default": "d 'de' MMMM 'de' y, HH:mm z",
        "short": "d MMM HH:mm z",
        "dateTime": "d MMM y, HH:mm",
        "dateTimeZone": "d MMM y, HH:mm z",
        "iso": "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
        "date": "d MMM y",
        "day": "dd",
        "monthShort": "MMM",
        "time": "HH:mm z",
        "year": "yyyy"
      }
    }
  }
}
